<app-loader *ngIf="isDisabled"></app-loader>
<div class="single-row-container">
	<div class="header-row">
		<div class="row w-100 gap-2">
			<div class="col align-content-center">
				<i class="bi bi-building-fill-check"></i>
				<span class="fw-bold ps-2">Shift Master</span>
			</div>
			<div class="col-auto p-0">
				<button type="button" class="upload-btn" id="exportBtn" *ngIf="this.common.PageRight.IsPrint"
					(click)="exportToExcel()" [disabled]="isDisabled">
					<i class="bi bi-download" *ngIf="!isDisabled"></i>
					<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
						*ngIf="isDisabled"></span>
					{{!isDisabled?'Export':'Loading...'}}
				</button>
			</div>
			<!-- <div class="col-auto p-0">
				<button *ngIf="this.common.PageRight.IsAdd" type="button" (click)="upload()" class="upload-btn"
					[disabled]="isDisabled">
					<i class="bi bi-upload" *ngIf="!isDisabled"></i>
					<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
						*ngIf="isDisabled"></span>
					{{!isDisabled?'Upload':'Loading...'}}
				</button>
			</div> -->
			<div class="col-auto p-0">
				<button *ngIf="this.common.PageRight.IsAdd" type="button" class="upload-btn" [disabled]="isDisabled"
					[routerLink]="['/master/shift/add/',0]">
					<i class="bi bi-plus" *ngIf="!isDisabled"></i>
					<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
						*ngIf="isDisabled"></span>
					{{!isDisabled?'Add Shift':'Loading...'}}
				</button>
			</div>
		</div>
	</div>
	<div class="m-3">
		<table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
			class="customeDatatable table table-bordered">
			<thead class="table-light">
				<tr>
					<th scope="col" style="width: 5px;">#</th>
					<th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
					<th>Shift Code</th>
					<th>Shift Name</th>
					<th>From Time</th>
					<th>To Time</th>
					<th>Working Hours</th>
					<th>Rotational Shift</th>
					<th>Default</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let TableData of TableDatas; let i = index">
					<th scope="row" style="width: 5px;">{{i+1}}</th>
					<td style="width: 5px;">
                        <div class="text-center" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                            <button class="btn btn-sm btn-warning" type="button"
                                [routerLink]="['/master/shift/add/',TableData['ShiftMasterid']]"><i
                                    class="bi bi-pencil-square"></i></button>
                        </div>
                    </td>
					<td>{{TableData['ShiftCode']}}</td>
					<td>{{TableData['ShiftTitle']}}</td>
					<td>{{TableData['InTime']}}</td>
					<td>{{TableData['OutTime']}}</td>
					<td>{{TableData['WorkingHourResult']}}</td>
					<td>{{TableData['RotationalShift']?'Yes':'No'}}</td>
					<td>{{TableData['DefaultShift']?'Yes':'No'}}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>


<!-- <button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample" (click)="downloadExcel()">
                        <i class="bi bi-file-earmark-excel" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Sample':'Loading...'}}
                    </button>
                    &nbsp;
                    <label *ngIf="this.common.PageRight.IsPrint" for="file-upload" class="btn btn-sm btn-primary">
                        <i class="bi bi-cloud-upload-fill" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled ? 'Excel Upload' : 'Loading...'}}
                    </label>
                    <input id="file-upload" type="file" style="display: none" (change)="handleFileInput($event)"
                        accept=".xls,.xlsx"> -->